module.exports = __webpack_public_path__ + "static/media/IZScreen Shot 2022-05-25 at 10.38.25 AM.3748cae7.png";